const CustomPlanPanel = ({ children, className, ...props }) => (
  <div className={`custom-plan-panel ${className}`} {...props}>
    {children}
  </div>
);

export default CustomPlanPanel;
